define('app/visualizations/SimpleCategoricalChartView',['require','./VisualizationView','glu/chartView','glu/util','moment','app/visualizations/FormatFactory','app/visualizations/ValidationView','app/app'],function(require) {
	'use strict';

	var VisualizationView = require('./VisualizationView'),
		ChartView = require('glu/chartView'),
		_ = require('glu/util'),
		Moment = require('moment'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		ValidationView = require('app/visualizations/ValidationView'),
		APP = require('app/app');

	var openReports = APP.openReports;

	return VisualizationView.extend({

		className: 'chart-container',
		template: function() {
			return '<div></div>';
		},

		initialize: function(options) {
			this.model = options.model;
			this.height = options.height || undefined;
			this.width = options.width || undefined;
			this.colors = options.colors || undefined;
			this.showTicks = options.showTicks === undefined ? true : options.showTicks;
			this.showLegend = options.showLegend === undefined ? true : options.showLegend;
			this.showLabels = options.showLabels === undefined ? true : options.showLabels;
			this.showSubchart = options.showSubchart === undefined ? true : options.showSubchart;
			this.isWidget = options.isWidget === undefined ? false : options.isWidget;
			this.fixToolTips = options.fixToolTips === undefined ? false : options.fixToolTips;
			this.paddingTop = options.paddingTop || 40;
			this.simpleDateFormat = options.simpleDateFormat;
			this.paddingRight = options.paddingRight || 40;
			this.paddingLeft = options.paddingLeft || 120;
			this.paddingBottom = options.paddingBottom || 80;
			this.grid = options.grid || {};
		},

		onClose: function() {
			if (this.chartView) {
				this.chartView.close();
			}

			this.remove();
			this.unbind();
		},

		onRender: function() {
			if (!this.model.results()) {
				return this;
			}

			this.data = this.model.consumableResults();

			if (this.canRenderReport()) {
				this.waitForContainerToRenderAndThen(this.drawChart);
			} else {
				this.renderIncompatibleMessage();
			}
			return this;
		},

		waitForContainerToRenderAndThen: function(callback) {
			_.defer(_.bind(callback, this));
		},

		drawChart: function() {
			this.renderChart(this.buildChart(this.data));
			this.removeLabelsFromLowerGraph();
		},

		removeLabelsFromLowerGraph: function() {
			// Temporary hack because we don't have a configuration option to turn off those labels via Glu or C3.
			var self = this;
			setTimeout(function() {
				self.$('.c3-axis-x').eq(1).find('text').remove();
			}, 500);
		},


		renderChart: function(chart) {
			chart.setElement(this.el);
			chart.render();
			this.model.trigger('graphRendered');
		},

		/**
		 * Get data used to populate the chart.
		 */
		getChartData: function(results) {
			return results.c3Data();
		},

		/**
		 * Get default options for rendering the chart.  Also provides callers the opportunity to customize
		 * various settings such as height, width, etc.
		 */
		getChartOptions: function(data) {
			var self = this;

			var getDataFormat = function(d) {
				if (data.options) {
					return FormatFactory.formatterForType(data.options.dataType, data.options)(d);
				} else {
					return d;
				}
			};

			var tooltipFormat = function(value, ratio, name) {
				var column, options;

				column = self.model.columns().models.filter(function(col) {
					// if asName isn't set, match the fieldObject name against the name with aggregation removed
					return col.get('asName') ? col.get('asName') === name : name.search(col.get('fieldObject').get('name')) > -1;
				})[0];

				options = {
					enumeration: column.get('enumeration'),
					aggregation: column.get('aggregation'),
					displayFormat: column.get('displayFormat')
				};

				if (column.get('isPercentage')) {
					options.percentage = {
						total: column.get('total')
					};
				}

				options.dataType = column.get('fieldObject').get('type');

				return FormatFactory.formatterForType(options.dataType, options)(value);
			};

			var options = {
				c3: {
					size: {
						height: this.height || this.$el.height(),
						width: this.width
					},
					legend: {
						position: 'inset',
						show: this.showLegend
					},
					subchart: {
						show: this.showSubchart && data.columns[0].length > 10
					},
					data: {
						x: 'x',
						type: this.type,
						columns: data.columns,
						groups: data.groups,
						onclick: function(d) {
							self.onClickChart(d);
						},
						show: this.showLabels
					},
					padding: {
						top: this.paddingTop,
						right: this.paddingRight,
						bottom: this.paddingBottom,
						left: this.paddingLeft
					},
					axis: {
						x: {
							type: 'category',
							extent: this.showSubchart ? [0, Math.min(10, data.columns[0].length - 1)] : [0, data.columns[0].length - 1],
							tick: {
								rotate: 0,
								culling: this.shouldCullXLabels()
							}
						},
						y: {
							min: 0,
							tick: {
								format: getDataFormat
							},
							padding: {
								bottom: 0
							}
						}
					},
					grid: this.grid,
					tooltip: {
						format: {
							value: tooltipFormat
						}
					}
				}
			};

			// Look for any edge cases
			if (this.simpleDateFormat) {
				options.c3.axis.x.tick.format = function(x) {
					return new Moment(data.columns[0][x + 1]).format('MM-DD');
				};
				options.c3.axis.x.tick.width = 200;
			}

			// special handling for tick marks.
			if (!this.showTicks) {
				this.$el.addClass('hide-ticks');

				options.c3.axis.x.tick = {
					outer: false
				};

				options.c3.axis.y.tick = {
					outer: false
				};
			}

			if (this.fixToolTips) {
				options.c3.tooltip.position = function() {
					return {
						top: 0,
						left: 0
					};
				};
			}

			return options;
		},

		buildChart: function(results) {
			// get data to populate the chart
			var data = this.getChartData(results);

			// get default options for rendering the chart
			var options = this.getChartOptions(data);

			this.chartView = this.createChartView(options);
			return this.chartView;

		},

		renderIncompatibleMessage: function() {
			var validationView = new ValidationView({
				model: this.model
			});

			this.$el.html(validationView.render().el);
			this.model.trigger('graphRendered');
		},

		createChartView: function(options) {
			return new ChartView(options);
		},

		shouldCullXLabels: function() {
			return false;
		},

		onClickChart: function(d) {
			this.drillDown(this.model.consumableResults().rows()[d.index].rolledUpFields);
		},

		drillDown: function(rolledUpFields) {
			var self = this;
			var report = this.model.clone();
			report.unset('id');
			_.each(rolledUpFields, function(f) {
				report.addFieldEqualsValueFilter(f.fieldId, f.value);
			});
			report.setGroupedAndAggregated(false);
			report.addSpdColumns();
			report.setVisualization('table');
			report.setName('Drill Down: ' + report.getName());
			report.setUrlOrigin(window.location.pathname);
			openReports.add(report);
			window.setTimeout(function() {
				self.navigateTo('/domains/' + report.getDomainId() + '/unsaved-report/' + report.cid);
			}, 0);
		}

	});

});

